var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[(_vm.show)?_c('v-system-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('marquee',[_vm._v(" "+_vm._s(_vm.showQuote)+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }